import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = import.meta.env.VITE_APP_DJANGO_BACKEND_HOST || '';

// Create axios instance with default config matching RTK Query setup
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Include cookies in requests (credentials: 'include')
});

// Add request interceptor to include CSRF token
axiosInstance.interceptors.request.use(
  (config) => {
    // Add CSRF token to headers
    const csrftoken = Cookies.get('csrftoken');
    if (csrftoken) {
      config.headers['X-CSRFToken'] = csrftoken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Add response interceptor to handle CSRF errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 400 || error.response?.status === 403) {
      const errorData = error.response?.data;

      // Check if the response contains "CSRF" & delete the cookie if it does
      // and the error message isn't that the CSRF token is missing
      if (
        errorData?.detail &&
        errorData.detail.includes('CSRF') &&
        !errorData.detail.includes('missing')
      ) {
        Cookies.remove('csrftoken');
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
